/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Activities undertaken by property/estate agent trades, selectable via CMS multi-select.
 */
export var PropertyActivity;

(function (PropertyActivity) {
  PropertyActivity["ESTATE_PROPERTY_MANAGEMENT_NON_RICS"] = "estate_property_management_non_rics";
  PropertyActivity["PROPERTY_SEARCH_AGENCY"] = "property_search_agency";
  PropertyActivity["ESTATE_AGENT_LETTING_AGENT"] = "estate_agent_letting_agent";
  PropertyActivity["PROPERTY_SOURCING"] = "property_sourcing";
  PropertyActivity["R2R_OPERATOR"] = "r2r_operator";
})(PropertyActivity || (PropertyActivity = {}));